import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { Box, Chip, Tooltip } from "@mui/material";
import { User } from "../../Model/UserModel";

const ROLE_LABEL: Record<string, string> = {
  SUPER_ADMIN: 'Super Admin',
  ADMIN: 'Admin',
  MANAGER: 'Gerente',
  USER: 'Usuário',
}

export function getColumns() {

  const columnsDesktop: GridColDef<any>[] = [
    {
      field: 'id',
      headerName: 'Id',
      type: 'number',
      width: 50,
      editable: false,
      hideable: false,
      filterable: false
    },
    {
      field: 'name',
      headerName: 'Nome',
      flex: 1,
      editable: false,
      hideable: false,
      filterable: false
    },
    {
      field: 'username',
      headerName: 'Username',
      width: 150,
      editable: false,
      align: 'right',
      hideable: false,
      filterable: false,
    },
    {
      field: 'isActive',
      headerName: 'Ativo',
      width: 80,
      editable: false,
      hideable: false,
      filterable: false,
      renderCell: (params: GridRenderCellParams<User>) => (
        <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
          <Chip
            label={params.row.isActive ? 'Sim' : 'Não'}
            size="small"
            color={params.row.isActive ? 'success' : 'default'}
            variant={params.row.isActive ? 'filled' : 'outlined'}
            sx={{ fontSize: 11 }}
          />
        </Box>
      ),
    },
    {
      field: 'suspendedAt',
      headerName: 'Suspenso',
      width: 110,
      editable: false,
      hideable: false,
      filterable: false,
      renderCell: (params: GridRenderCellParams<any>) => {
        const suspended = params.row.suspendedAt
        const expiresAt = params.row.suspensionExpiresAt
        if (!suspended) return (
          <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
            <Chip label="Normal" size="small" color="success" variant="outlined" sx={{ fontSize: 11 }} />
          </Box>
        )
        const expiryDate = expiresAt ? new Date(expiresAt).toLocaleDateString('pt-BR') : null
        return (
          <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
            <Tooltip title={expiryDate ? `Até ${expiryDate}` : 'Suspensão indefinida'}>
              <Chip
                label={expiryDate ? `Até ${expiryDate}` : 'Suspenso'}
                size="small"
                color="warning"
                variant="filled"
                sx={{ fontSize: 11 }}
              />
            </Tooltip>
          </Box>
        )
      },
    },
    {
      field: 'validUntil',
      headerName: 'Valido até',
      type: 'string',
      width: 130,
      editable: false,
      align: 'right',
      hideable: false,
      filterable: false,
      renderCell: (params: GridRenderCellParams<User>) => {
        const validUntil = params.row.validUntil;
        return validUntil ? validUntil : "vitalício"
      }
    },
    {
      field: 'role',
      headerName: 'Tipo',
      type: 'string',
      width: 110,
      editable: false,
      align: 'right',
      hideable: false,
      filterable: false,
      renderCell: (params: GridRenderCellParams<User>) => (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', height: '100%' }}>
          <Chip
            label={ROLE_LABEL[params.row.role] ?? params.row.role}
            size="small"
            color={params.row.role === 'SUPER_ADMIN' ? 'primary' : params.row.role === 'ADMIN' ? 'secondary' : 'default'}
            variant="outlined"
            sx={{ fontSize: 11 }}
          />
        </Box>
      ),
    },
  ];

  const columnsMobile: GridColDef<any>[] = [
    {
      field: 'name',
      headerName: 'Nome',
      flex: 1,
      editable: false,
      hideable: false,
      filterable: false,
      renderCell: (params: GridRenderCellParams<any>) => (
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', height: '100%', overflow: 'hidden' }}>
          <Box sx={{ fontWeight: 600, fontSize: 13, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {params.row.name}
          </Box>
          <Box sx={{ fontSize: 11, color: 'text.secondary' }}>
            {ROLE_LABEL[params.row.role] ?? params.row.role}
          </Box>
        </Box>
      ),
    },
    {
      field: 'isActive',
      headerName: 'Status',
      width: 72,
      editable: false,
      hideable: false,
      filterable: false,
      renderCell: (params: GridRenderCellParams<any>) => (
        <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
          <Chip
            label={params.row.isActive ? 'Ativo' : 'Inativo'}
            size="small"
            color={params.row.isActive ? 'success' : 'default'}
            variant="outlined"
            sx={{ fontSize: 10 }}
          />
        </Box>
      ),
    },
  ];
  return [columnsDesktop, columnsMobile]
}
